import { useEndpointFacade } from '@/facade/api.js';
import { API_ROUTE } from '@common/schema/api.js';
import { parseItems } from '@/hook/market/items.js';

const defaults = {
  order: [{ field: 'bumped_at', order: 'DESC' }],
  limit: 5,
  offset: 0,
};

const featuredConnector = (game_app_id) => useEndpointFacade({
  endpoint: API_ROUTE.market.search[game_app_id],
});

let ttl = 0;
const cached = {};

export const getFeaturedItems = async (app_id) => {
  const now = Date.now();
  if (now - ttl < 30_000 && cached[app_id]) {
    return cached[app_id];
  }
  const connector = featuredConnector(app_id);
  const result = parseItems((await connector.call(defaults)));
  cached[app_id] = result;
  ttl = now;
  return result;
};
